import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import {
  ClickAwayListener,
  IconButton,
  MenuItem,
  Paper,
  Popper,
} from '@mui/material';
import { MoreVert, DeleteRounded } from '@mui/icons-material';
import { COLOR } from '@src/styles/color';
import { StyledRowMenu } from './index.style';

const MENU_PAPER_SX = {
  borderRadius: '8px',
  boxShadow: '0 4px 16px 0 rgba(0, 0, 0, 0.08)',
};

// Popper sits the menu against the button; the design leaves a gap.
const MENU_MODIFIERS = [{ name: 'offset', options: { offset: [0, 6] } }];

// `open` is owned by the list, so opening one row closes any other.
const RowActions = ({ open, onOpenChange, onDelete }) => {
  const { t } = useTranslation();
  const anchorRef = useRef(null);

  // Clicking the row opens the project, so the menu must not bubble up to it.
  const stop = (e, run) => {
    e.stopPropagation();
    run();
  };

  return (
    <>
      <IconButton
        ref={anchorRef}
        onClick={(e) => stop(e, () => onOpenChange(!open))}
      >
        <MoreVert sx={{ color: COLOR.indigo[64] }} />
      </IconButton>

      {/* Mounted only while open, so closed rows hold no document listener. */}
      {open && (
        <ClickAwayListener onClickAway={() => onOpenChange(false)}>
          <Popper
            open
            anchorEl={anchorRef.current}
            placement="left-start"
            modifiers={MENU_MODIFIERS}
            style={{ zIndex: 1000 }}
          >
            <Paper sx={MENU_PAPER_SX}>
              <StyledRowMenu>
                <MenuItem
                  className="row-menu-item"
                  onClick={(e) =>
                    stop(e, () => {
                      onOpenChange(false);
                      onDelete();
                    })
                  }
                >
                  <DeleteRounded className="row-menu-icon" />
                  <span>{t('delete')}</span>
                </MenuItem>
              </StyledRowMenu>
            </Paper>
          </Popper>
        </ClickAwayListener>
      )}
    </>
  );
};

export default RowActions;
